import {
	JobEventApiDto,
	JobSurveyCreatedEventDataApiDto
} from "../../../api/model/rest";
import AuthenticatedEntity from "../../user/AuthenticatedEntity";
import Attachment from "../../attachment/Attachment";
import moment = require("moment");
import JobEvent, {JobEventTypeEnum} from "./JobEvent";
import {option, Option} from "ts-option";
import {Icon} from "../../../hiberUiKit/src/atoms/Icon/Icon";
import {IconColor} from "../../../hiberUiKit/src/molecules/StreamItem/StreamItemIcon";

export default class JobSurveyCreatedEvent extends JobEvent {
	/**
	 * @param {string} id identifier of event.
	 * @param {string} jobId job id.
	 * @param {JobEventTypeEnum} type type of the event.
	 * @param {AuthenticatedEntity} entity entity which creates the event.
	 * @param {moment.Moment} creationDate creation date of event.
	 * @param {string} referenceNumber job reference number.
	 * @param data job survey file
	 */
	constructor(public readonly id: string,
		public readonly jobId: string,
		public readonly type: JobEventTypeEnum,
		public readonly entity: AuthenticatedEntity,
		public readonly creationDate: moment.Moment,
		public readonly referenceNumber: string,
		public readonly data: JobSurveyCreatedEventData) {
		super(id, jobId, type, entity, creationDate, referenceNumber);
	}

	public static fromJson(json: JobEventApiDto): JobSurveyCreatedEvent {
		const data = JobSurveyCreatedEventData.fromJson(json.data as JobSurveyCreatedEventDataApiDto);
		const entity = AuthenticatedEntity.fromJson(json.entity);
		return new JobSurveyCreatedEvent(json.id,
			json.jobId,
			JobEventTypeEnum.SurveyCreated,
			entity,
			moment(json.createdAt),
			json.referenceNumber,
			data);
	}

	getIcon() {
		return Icon.File;
	}

	getIconColor(): IconColor {
		return IconColor.Burgundy;
	}

	getActivityAdditionalMessages() {
		return this.data.surveyDescription.map(d => [d]).getOrElse([]);
	}

	getAttachments(): Attachment[] {
		return this.data.attachments;
	}

	getActivityType() {
		return "SURVEY"
	}

	getActivityMessage(): string {
		return "Survey created";
	}
}

export class JobSurveyCreatedEventData {
	constructor(public readonly surveyId: string,
		public readonly attachments: Attachment[],
		public readonly surveyDescription: Option<string>) {}

	public static fromJson(json: JobSurveyCreatedEventDataApiDto): JobSurveyCreatedEventData {
		return new JobSurveyCreatedEventData(json.surveyId, json.attachments.map(Attachment.fromJson), option(json.surveyDescription));
	}
}
